<template>
  <div class="review-item">
    <blockquote>
      <p class="review-text">{{ item.content ? item.content : "-" }}</p>
      <div class="rating-row row">
        <div class="col-xs-4 col-sm-4 mb-2">
          <b>{{ $t("text.quantity") }} :</b>
          <el-rate
            disabled
            :value="parseFloat(item.food_rating)"
            :icon-classes="iconClassesLocation"
            void-icon-class="k-icon-forkstar"
            :max="max"
            :colors="ratingIconColors"
          ></el-rate>
        </div>
        <div class="col-xs-4 col-sm-4 mb-2">
          <b
            >{{
              item.order.order_type == ORDER_TYPE.Delivery.id
                ? $t("text.delivery")
                : item.order.order_type == ORDER_TYPE.Collection.id
                ? $t("text.collection")
                : $t("text.table")
            }}:</b
          >
          <el-rate
            disabled
            :value="parseFloat(item.collection_delivery_rating)"
            :icon-classes="iconClassesLocation"
            void-icon-class=" k-icon-forkstar"
            :max="max"
            :colors="ratingIconColors"
          ></el-rate>
        </div>
        <div class="col-xs-4 col-sm-4 mb-2">
          <b>{{ $t("text.service") }}:</b>
          <el-rate
            disabled
            :value="parseFloat(item.service_rating)"
            :icon-classes="iconClassesLocation"
            void-icon-class="forkstar-outline"
            :max="max"
            :colors="ratingIconColors"
          ></el-rate>
        </div>
      </div>
      <small>
        {{ userFullName(item.user) }} {{ $t("text.from") }}
        <cite title="Source Title">{{ item.location.name }}</cite>
        {{ $t("text.on") }}
        {{ generateFormatedDateTime(item.created_at, "date", $i18n.locale) }}
      </small>
    </blockquote>
  </div>
</template>
<script>
import { ORDER_TYPE } from "@/utilities/enums";
import { generateFormatedDateTime } from "@/utilities/helper";
import staticColors from "@/model/colors";
export default {
  name: "review-item",
  props: {
    item: Object,
  },
  data() {
    return {
      generateFormatedDateTime,
      ORDER_TYPE,
      iconClassesLocation: [
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
        "k-icon-forkstar-outline",
      ],
      ratingIconColors: [
        "#99A9BF",
        staticColors.ratingOkey,
        staticColors.ratingGood,
      ],
      value: 7,
      max: 7,
    };
  },
  filters: {
    parseFloat: function (value) {
      if (!value) return 0;
      return parseFloat(value);
    },
  },
  computed: {
    userFullName() {
      return (user) => {
        return user ? `${user.first_name} ${user.last_name} ` : "-";
      };
    },
  },
};
</script>
<style scoped>
.form-group.input-group,
.form-group.input-group {
  padding: 0 !important;
}
</style>
